//FB 9639
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { createTheme } from "@material-ui/core/styles"; //FB 9639
import { Box, Button, TextareaAutosize } from "@mui/material";
import {
  SendMessage,
  GetSelectedMessage,
} from "../../../../api"; //FB 9639
import useMediaQuery from "@mui/material/useMediaQuery";
import { Message, Recipient } from "../../../../store"; //FB 9639

// update log
// FB 7074 SK     07/21/2023    Patient Portal : Develop the feature of message reply- New Screen for Reply
// FB 7160 SK     08/01/2023    Delete Unused package reference
// FB 8934 GS     09/30/2024    Staff should not have Dr in front of it
// FB 9639 DK     12/02/2024    Employee Groups that are Set to be Portal Addressees.

export default function Reply() {
  //FB 9639 Performed code cleaning and optimizing - Start
  const location = useLocation();
  const matches = useMediaQuery("(min-width:600px)");
  const stylestop = {
    container: {
      height: "auto",
      border: "1px grey",
    },
  };
  const p_wrap = {
    container: {
      whiteSpace: "pre-line",
    },
  };
  const [message, setMessage] = useState<Message>({} as Message);
  var userInitialState = {
    Login: "",
    Patient_n: 0,
    EMRID: "",
    PatientFirstName: "User",
    PatientLastName: "",
    PatientZIP: "",
    PatientDOB: "",
    PatientGender: "",
    IsGuardian: "",
    Guardian: "",
  }
  var userInfo = sessionStorage.getItem("user");
  var user = userInfo != null ? JSON.parse(userInfo) : userInitialState;
  const [currentRecipient, setCurrentRecipient] = useState<Recipient>();
  const [sentcard, setSentcard] = useState(false);
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const navigate = useNavigate();
  const handleClose = () => {
    setSentcard(false);
  };
  const handleMailClose = () => {
    setSentcard(false);
    navigate("/user/home/messages");
  };
  const JSAlert = require("js-alert");
  const SendReply = async (event: any) => {
    let body = content.replace(/\n\r?/g, "<br/>");
    await SendMessage(user.Patient_n, message.PhysicianID, subject, body, message.Is_Group_Message);
    setSentcard(true);
  };
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  async function LoadMessage() {
    let messageID = sessionStorage.getItem("MessageID");
    if (messageID != null) {
      let messageInfo = await GetSelectedMessage(Number(messageID));
      if (messageInfo != null) {
        let recipient = (location.state as Recipient[]).filter((rcp: any) => rcp.Is_Group == messageInfo.Is_Group_Message).find(
          (rcp: any) => rcp.ID == messageInfo.PhysicianID
        ) as Recipient;
        setCurrentRecipient(recipient);
        setMessage(messageInfo);
        setSubject(messageInfo.Subject);
        let dateSent = messageInfo.DateSent;
        let convertedDate = new Date(dateSent)
          .toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
          .replace(",", "");
        let body =
          "\n" +
          "\n" +
          "\n" +
          "<------------- Original Message ------------->" +
          "\n" +
          ">> From : " +
          recipient.Name +
          "\n" +
          ">>Sent : " +
          convertedDate +
          "\n" +
          ">>To : " +
          user.PatientFirstName +
          "\n" +
          ">>Subject : " +
          messageInfo.Subject +
          "\n" +
          ">>" +
          messageInfo.Body.replaceAll("<br>", "\n");
        setContent(body);
        setTimeout(() => {
          fnFocus("textArea");
        }, 3000);
      }
    };
  }

  function fnFocus(id: string): void {
    const input = document.getElementById(id) as HTMLInputElement;
    input.focus();
    input.setSelectionRange(0, 0);
  }

  useEffect(() => {
    LoadMessage();
  }, []);
  //FB 9639 Performed code cleaning and optimizing - End

  return (
    <div>
      <div
        className="row"
        style={{
          marginBottom: "30px",
        }}
      >
        <div className="col-sm-12">
          <div className="card" style={stylestop.container}>
            <div className="card-body">
              <p className="card-title" style={{ textAlign: "left" }}>
                <strong> Reply Message</strong>
              </p>
              <hr></hr>
              <div className="row">
                {/* FB 9639 */}
                <span style={{ textTransform: "capitalize" }}>
                  {/* FB 8934 Removed "Dr. " prefix */}
                  <strong>{currentRecipient?.Name}</strong>
                </span>
              </div>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Subject : </strong>{" "}
                <input
                  id="standard-basic"
                  name="Subject"
                  value={subject}
                  onChange={(e: any) => {
                    setSubject(e.target.value);
                  }}
                  style={{
                    width: matches == false ? "300px" : "400px",
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                  }}
                ></input>{" "}
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <p className="card-text" style={{ textAlign: "left" }}>
                  <strong>Message: </strong>{" "}
                </p>
              </p>
              <div className="col-sm-12">
                <TextareaAutosize
                  id="textArea"
                  autoFocus={true}
                  className="p_wrap"
                  aria-label="minimum height"
                  minRows={8}
                  style={{
                    height: "200px",
                    whiteSpace: "pre-line",
                    width: "calc(100% - 5px)",
                  }}
                  value={content}
                  onChange={(e: any) => {
                    setContent(e.target.value);
                  }}
                />
              </div>
              {/* FB 9639 */}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={SendReply}
              >
                Send
              </Button>{" "}
              {""}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={() => navigate("/user/home/messages")}
              >
                Cancel
              </Button>
              <Dialog open={sentcard} onClose={handleClose}>
                <DialogContent
                  style={{
                    maxWidth: "850px",
                    height: "150px",
                  }}
                >
                  {/* FB 9639 */}
                  <h5 style={{ textAlign: "center" }}>
                    Message sent to {currentRecipient?.Name} Successfully!
                  </h5>
                  <br></br>
                  <Box display="center" justifyContent="center">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#13607C",
                        color: "white",
                      }}
                      onClick={handleMailClose}
                    >
                      Ok
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
//FB 9639 Moved to top